import CollapsedLogoIcon from '../CollapsedLogoIcon';
import { DASHBOARD_PATH } from '@/common/main/config';
import Link from '@mui/material/Link';
import LogoIcon from '@/common/presentation/components/LogoIcon';
import { Link as RouterLink } from 'react-router-dom';
import { memo } from 'react';
import tid from '@/common/infrastructure/config/tid';

interface LogoProps {
  expanded: boolean;
}

const Logo = ({ expanded }: LogoProps) => (
  <Link component={RouterLink} to={DASHBOARD_PATH} {...tid('common:layout:logo-link')} aria-label="theme-logo">
    {expanded ? <LogoIcon /> : <CollapsedLogoIcon />}
  </Link>
);

export default memo(Logo);
